import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/* Kenya international format: 0722148999 → +254722148999 */
const WA_NUMBER  = '254722148999';
const WA_MESSAGE = encodeURIComponent(
  'Hello Lidav Enterprises! I would like to enquire about your services.'
);
const WA_URL = `https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`;

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center gap-3">
      {/* Tooltip label — slides in on hover */}
      <AnimatePresence>
        {hovered && (
          <motion.div
            initial={{ opacity: 0, x: 12, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 12, scale: 0.9 }}
            transition={{ duration: 0.22, ease: 'easeOut' }}
            className="bg-white rounded-xl shadow-xl px-4 py-2.5 border border-gray-100 pointer-events-none"
          >
            <p className="font-semibold font-poppins text-gray-900 text-sm whitespace-nowrap">
              Chat on WhatsApp
            </p>
            <p className="text-gray-400 font-inter text-xs mt-0.5 whitespace-nowrap">
              0722 148 999 — typically instant
            </p>
          </motion.div>
        )}
      </AnimatePresence>

      {/* WhatsApp button — direct wa.me API link */}
      <motion.a
        href={WA_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with Lidav Enterprises on WhatsApp — 0722 148 999"
        whileHover={{ scale: 1.12 }}
        whileTap={{ scale: 0.93 }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onFocus={() => setHovered(true)}
        onBlur={() => setHovered(false)}
        className="relative w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-xl wa-pulse hover:bg-[#20b957] transition-colors focus:outline-none focus:ring-4 focus:ring-[#25D366]/40"
      >
        {/* WhatsApp icon */}
        <svg viewBox="0 0 32 32" className="w-8 h-8 fill-white" aria-hidden="true">
          <path d="M16.004 2.667C8.636 2.667 2.667 8.636 2.667 16c0 2.337.626 4.527 1.71 6.422L2.667 29.333l7.12-1.676A13.27 13.27 0 0 0 16.004 29.333C23.372 29.333 29.333 23.364 29.333 16c0-7.364-5.961-13.333-13.33-13.333zm0 2.413c6.032 0 10.92 4.888 10.92 10.92 0 6.031-4.888 10.92-10.92 10.92a10.88 10.88 0 0 1-5.466-1.463l-.392-.234-4.08.96.994-3.958-.256-.408A10.867 10.867 0 0 1 5.084 16c0-6.032 4.888-10.92 10.92-10.92zM11.65 10.2c-.197 0-.516.074-.786.37-.27.296-1.034 1.01-1.034 2.463s1.059 2.856 1.207 3.053c.148.197 2.07 3.162 5.014 4.31 2.944 1.148 2.944.766 3.476.717.53-.049 1.713-.7 1.957-1.38.245-.677.245-1.26.171-1.38-.073-.12-.27-.196-.567-.344-.296-.148-1.75-.863-2.02-.96-.27-.1-.468-.148-.666.149-.197.296-.765.96-.938 1.158-.173.197-.344.222-.64.073-.296-.148-1.25-.46-2.382-1.47-.88-.786-1.474-1.756-1.647-2.052-.172-.296-.018-.456.13-.604.132-.133.295-.344.443-.516.148-.172.197-.296.296-.493.1-.197.05-.37-.024-.517-.074-.148-.665-1.605-.912-2.198-.24-.574-.485-.496-.666-.506l-.567-.01a1.09 1.09 0 0 0-.789.37z"/>
        </svg>

        {/* Online indicator dot */}
        <span className="absolute top-0.5 right-0.5 w-3.5 h-3.5 bg-white rounded-full flex items-center justify-center">
          <span className="w-2 h-2 bg-brand-red rounded-full animate-pulse" />
        </span>
      </motion.a>
    </div>
  );
}
